export type AppMode = 'accounting' | 'projects' | 'sustainability';

export const LANDING_PAGE_VALUES = ['accounting', 'projects', 'sustainability'] as const;

export const DEFAULT_LANDING_PAGE: AppMode = 'accounting';

export const APP_MODES: { value: AppMode; label: string }[] = [
  { value: 'accounting', label: 'Accounting' },
  { value: 'projects', label: 'Projects' },
  { value: 'sustainability', label: 'Sustainability' },
];
